import { IAppState } from '@myStore/app.state';
import { IUsersChangesState } from '@myStore/users-changes/users-changes.state';
import { createSelector } from '@ngrx/store';

const usersChangesSelector = (state: IAppState) => state.usersChanges;

export const selectUsersChangesLoading = createSelector(
  usersChangesSelector,
  (state: IUsersChangesState) => state?.isLoading
);

export const selectUsersChangesSuccess = createSelector(
  usersChangesSelector,
  (state: IUsersChangesState) => state?.success
);

export const selectUsersChangesFailure = createSelector(
  usersChangesSelector,
  (state: IUsersChangesState) => state?.errors
);
